import React from 'react'
import { Helmet } from 'react-helmet'

const Intro = () => {
    return (
        <div>
            <Helmet>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "WebSite",
                            "name": "Murage Juma & Company Advocates",
                            "url": "https://jncmlaw.co.ke",
                            "description": "Dedicated to Justice, Driven by Integrity",
                            "publisher": {
                                "@type": "Organization",
                                "name": "Murage Juma & Company Advocates",
                                "logo": "https://jncmlaw.co.ke/logo512.png",
                            },
                        }),
                    }}
                />
                {/* <title>Murage Juma & Company Advocates</title> */}
                <meta name="description" content='Dedicated to Justice, Driven by Integrity' />
                <meta name="author" content="Designed by Mutai" />
                <meta name="publisher" content="Designed by Mutai" />
                <meta name="robots" content="index, follow" />
                <meta name="google-site-verification" content="mmxN3C8BY0isfRqwrpBiUKir_kx3CnHvOHQcRDrw9Ic" />
                <meta name="keywords" content="joseph murage, joe murage, joseph nicholas Murage, josé murage, juma kagoro, john patrick machira, law firm, law associates, kenya law, kenya lawyers, kenyan law firm, murage juma & company advocates, commissioners for oaths, notaries public, agri business, agri, debt collection, succession law, intellectual property law, sale of property, sale of assets, family law, civil litigation, commercial litigation, natural resource law research, energy and natural resource law research, legal entity formation, securities perfection, banking securities, project finance securities, Civil and Commercial Litigation, Immigration Law Advisory and Ancillary Services" />
                <meta name="robots" content="index, follow" />

                {/* Open Graph (Facebook, LinkedIn) */}
                <meta property="og:title" content="Murage Juma & Company Advocates" />
                <meta property="og:description" content="Dedicated to Justice, Driven by Integrity" />
                <meta property="og:site_name" content="Murage Juma & Company Advocates" />
                <meta property="og:image" content="%PUBLIC_URL%/og-image.jpg" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content='https://jncmlaw.co.ke/' />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Murage Juma & Company Advocates" />
                <meta name="twitter:description" content="Dedicated to Justice, Driven by Integrity" />
                <meta name="twitter:image" content="%PUBLIC_URL%/twitter-image.jpg" />

            </Helmet>
            <div
                className='4xl:px-[5%]'
            >
                <div
                    className='relative flex flex-col xs:items-center lg:items-start xs:text-center lg:text-left justify-center z-[300] lg:pl-[9%] 2xl:pl-[12%] xs:h-[calc(100vh-15rem)] xsp:h-[calc(100vh-12rem)] md:h-[calc(100vh-15rem)] lg:h-[calc(100vh-10rem)] xl:h-[calc(100vh-15rem)] 2xl:h-[calc(100vh-15rem)] 2xl:py-[12rem] xs:w-full lg:w-[55%] 2xl:w-[55%] 3xl:w-[50%] xs:mt-[7rem] md:mt-[15rem] lg:mt-0 xl:-mt-[2rem] 2xl:mt-0'
                >
                    <h3
                        className="playfair xs:text-[2.15rem] xsp:text-[2.5rem] md:text-[3.5rem] lg:text-[2.25rem] xl:text-[2.75rem] 2xl:text-[4rem] xs:leading-[2rem] xsp:leading-[2.25rem] md:leading-[3.25rem] lg:leading-[2rem] xl:leading-[2.25rem] 2xl:leading-[3.25rem] 4xl:leading-[3.5rem] bg-gradient-to-b from-primaryRichBlue via-primaryRichBlue to-primaryRichGreen bg-clip-text text-transparent xs:pb-[0.75rem] lg:pb-[0.85rem]"
                    >
                        Dedicated to Justice,
                        <br />
                        Driven by Integrity.
                    </h3>
                    <h4
                        className='alata -mt-[0.75rem] xs:text-[1.05rem] xsp:text-[1.15rem] md:text-[1.65rem] lg:text-[1.15rem] xl:text-[1.25rem] 2xl:text-[1.85rem] text-primaryGreen'
                    >
                        Empowering you in every legal challenge.
                    </h4>
                    <div
                        className='outfit text-justify text-slate-600/90 font-[500] xs:px-[1.5rem] md:px-[15%] lg:px-0 xs:text-[0.7rem] xsp:text-[0.85rem] md:text-[1rem] lg:text-[0.75rem] xl:text-[0.85rem] 2xl:text-[1rem] xs:leading-[1.15rem] xsp:leading-[1.25rem] md:leading-[1.75rem] lg:leading-[1.1rem] xl:leading-[1.25rem] 2xl:leading-[1.5rem] xsp:mt-[1rem] lg:mt-0'
                    >
                        <p className='mt-[1rem]'>
                            Founded in 2016 by Joseph Nicholas Murage &amp; Juma Kagoro, the firm of Murage Juma and Co. was established to offer stellar legal services at all echelons of legal practice in Kenya. Murage Juma and Company (MJC) comprises of a vibrant result-oriented team whose experience, dynamism &amp; decisive problem solving skills enable us to have &amp; maintain the fast paced growth &amp; diversity of our Client Base.
                        </p>
                        <p className='xs:mt-[1rem] xl:mt-[1.5rem] 2xl:mt-[2rem] font-[700] text-slate-600/90'>
                            MJC is and shall always be committed to quality service delivery &amp; remains alert to market demand.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Intro